import React from 'react';
import PropTypes from 'prop-types';
import { addLocationValue, removeLocationValue } from 'apps/web_forms/slices/multimediaSlice';
import { useDispatch } from 'react-redux';
import Map from './Map';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

const FormMap = ({ element }) => {
  const dispatch = useDispatch();

  const {locationValues} = useGlobalSelector();
  const locationValue = locationValues[element.identifier];

  const mapLocationHandler = (center, locationStrings) => {
    dispatch(
      addLocationValue({
        key: element.identifier,
        value: {
          center,
          string: locationStrings?.string,
          shortString: locationStrings?.shortString,
          positionInfo: locationStrings?.position,
        },
      })
    );
  };

  const mapRemoveButtonHandler = () => {
    dispatch(removeLocationValue(element.identifier));
  };

  return (
    <Map
      getLocationHandler={mapLocationHandler}
      removeLocationHandler={mapRemoveButtonHandler}
      defaultLocation={locationValue?.center}
      defaultMessage={locationValue?.positionInfo}
      canOverride={element?.allow_manual_override}
      locationButtonColor="white"
    />
  );
};

FormMap.propTypes = {
  element: PropTypes.shape({
    identifier: PropTypes.string,
    allow_manual_override: PropTypes.bool,
  }).isRequired,
};

export default FormMap;
